import React from 'react';
import cx from 'classnames';

import { GetStaff } from '@querys/getStaff';
import { BlockWrapper } from '../blockWrapper';

import Email from '@svg/email.svg';
import EmailBlack from '@svg/email-black.svg';

const OurStaff = ({ heading, whiteText, blockConfig }) => {
  const staff = GetStaff();

  const sortedStaff = staff.sort(function (a, b) {
    var textA = a.name.split(' ')[1]?.toUpperCase();
    var textB = b.name.split(' ')[1]?.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });

  // sort sortedStaff by pin
  const sortedStaffPinned = sortedStaff.sort(function (a, b) {
    return b.pin - a.pin;
  });

  return (
    <BlockWrapper {...blockConfig} className='grid grid-cols-14'>
      <div
        className={cx('col-start-2 col-end-14', {
          'text-white': whiteText,
          'text-black': !whiteText,
        })}>
        <h2 className='text-3xl leading-3xl md:text-5xl md:leading-5xl font-medium md:font-regular'>
          {heading}
        </h2>
        <div className='mt-8 lg:mt-16'>
          {sortedStaffPinned.map((person, i) => {
            const { name, position, emailLink } = person || {};
            return (
              <div
                key={i}
                className={`${
                  i === 0 ? 'pt-0' : 'pt-5 border-t mt-5'
                } flex flex-col lg:grid lg:grid-cols-3 text-base leading-base`}>
                <h6 className='font-semibold md:font-medium'>{name}</h6>
                <p>{position}</p>
                <div className='flex flex-row justify-start items-center mt-2 lg:mt-0'>
                  {whiteText ? <Email /> : <EmailBlack />}
                  <a
                    className='ml-4 hover:opacity-50 transition duration-300 ease-in-out'
                    href={`mailto:${emailLink}`}>
                    {emailLink}
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </BlockWrapper>
  );
};

export default OurStaff;
